import React from 'react';

const TitlePage = React.forwardRef(({ title, subtitle, year, dedication }, ref) => {
  return (
    <div ref={ref} className="book-page" data-density="hard" style={{ backgroundColor: '#FFFFFF' }}>
      <div className="absolute inset-0 bg-white flex flex-col justify-center px-6 sm:px-8 py-6 overflow-hidden">
        {/* Large year watermark */}
        <div
          className="absolute top-4 right-0 select-none pointer-events-none"
          style={{
            fontFamily: "'Space Mono', monospace",
            fontSize: 'clamp(60px, 15vw, 120px)',
            fontWeight: 700,
            color: 'rgba(159, 18, 57, 0.06)',
            lineHeight: 1,
          }}
        >
          {year}
        </div>

        <div className="relative z-10">
          <h1
            className="text-lg sm:text-xl font-bold text-gray-900 leading-tight mb-1"
            style={{ fontFamily: "'Sora', sans-serif" }}
          >
            {title}
          </h1>

          {subtitle && (
            <p
              className="text-xs sm:text-sm text-gray-500 mb-4"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
            >
              {subtitle}
            </p>
          )}

          <div className="w-8 h-0.5 bg-rose-700 rounded-full mb-4" />

          <p
            className="text-xl sm:text-2xl font-bold text-rose-700"
            style={{ fontFamily: "'Space Mono', monospace" }}
          >
            {year}
          </p>

          {dedication && (
            <div className="mt-6 pl-3 border-l-2 border-amber-500 bg-gray-50 rounded-r py-2.5 pr-3">
              <p
                className="text-[10px] sm:text-xs italic text-gray-600 leading-relaxed"
                style={{ fontFamily: "'DM Sans', sans-serif" }}
              >
                {dedication}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

TitlePage.displayName = 'TitlePage';
export default TitlePage;
